export default __webpack_public_path__ + "static/media/page-forgot-password.2b85b8d0.jpg";